//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount
import com.tixforgigs.apax.models.PriceAdditionalInfo

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The product price info model
* 
* @param presaleFee 
* @param presaleTaxRate The presale tax rate in percent
* @param totalPrice 
* @param unitPrice 
* @param priceAdditionInfos Additional price infos. The club euro for instance
* @param unitTaxRate The unit tax rate in percent. This information is provided for informational purposes only. All payments are transitory items at TixforGigs and must be taxed by the organizer.
*/
@Serializable

data class PriceInfo (


      @SerialName(value = "presaleFee") @Required val presaleFee: Amount,


      /* The presale tax rate in percent */
    @SerialName(value = "presaleTaxRate") @Required val presaleTaxRate: kotlin.Double,


      @SerialName(value = "totalPrice") @Required val totalPrice: Amount,


      @SerialName(value = "unitPrice") @Required val unitPrice: Amount,


      /* Additional price infos. The club euro for instance */
    @SerialName(value = "priceAdditionInfos") val priceAdditionInfos: kotlin.collections.List<PriceAdditionalInfo>? = null,


      /* The unit tax rate in percent. This information is provided for informational purposes only. All payments are transitory items at TixforGigs and must be taxed by the organizer. */
    @SerialName(value = "unitTaxRate") val unitTaxRate: kotlin.Double? = null


) {




  }

